import { useBlockProps, InnerBlocks, RichText } from '@wordpress/block-editor';

const v1 = {
	attributes: {
		body: {
			type: 'array',
			source: 'children',
			selector: '.asl-cta-2-text',
		},
		backgroundColor: {
			type: 'string',
			default: '#f4f4f4',
		},
		btnText: {
			type: 'string',
			default: '',
			source: 'html',
			selector: '.asl-btn-cta-2',
		},
		btnStyle: {
			type: 'string',
			default: 'outline',
		},
		btnBackground: {
			type: 'string',
			default: '',
		},
		btnColor: {
			type: 'string',
			default: '',
		},
		btnBorderRadius: {
			type: 'number',
			default: 1,
		},
		btnBorderWidth: {
			type: 'number',
			default: 2,
		},
		btnBorderColor: {
			type: 'string',
			default: '',
		},
		btnHoverBackground: {
			type: 'string',
		},
		btnHoverColor: {
			type: 'string',
		},
		btnLink: {
			type: 'string',
			source: 'attribute',
			selector: '.asl-btn-cta-2',
			attribute: 'href',
		},
		rel: {
			type: 'string',
			source: 'attribute',
			selector: 'a',
			attribute: 'rel',
			default: 'sponsored nofollow',
		},
		target: {
			type: 'boolean',
			default: false,
		},
	},
	save({ attributes }) {
		const {
			title,
			body,
			alignment,
			borderColor,
			borderWidth,
			borderRadius,
			btnText1,
			btnText2,
			btnStyleFirst,
			btnStyleSecond,
			btnBackgroundFirst,
			btnBackgroundSecond,
			borderRadiusFirst,
			borderRadiusSecond,
			borderWidthFirst,
			borderWidthSecond,
			btnBorderColorFirst,
			btnBorderColorSecond,
			btnLinkFirst,
			btnLinkSecond,
			btnColorFirst,
			btnColorSecond,
			rel,
			target,
		} = attributes;

		const blockProps = useBlockProps.save({
			className: 'asl-cta-1',
		});
		return (
			<div
				{...blockProps}
				style={{
					borderColor,
					borderWidth,
					borderRadius,
				}}
			>
				<InnerBlocks.Content />
				<h3 style={{ textAlign: alignment }}>{title}</h3>
				<div className="asl-cta-1-buttons">
					<RichText.Content
						tagName="a"
						value={btnText1}
						style={
							btnStyleFirst === 'fill'
								? {
										color: btnColorFirst,
										backgroundColor: btnBackgroundFirst,
										borderRadius: borderRadiusFirst,
								  }
								: {
										borderWidth: borderWidthFirst,
										borderColor: btnBorderColorFirst,
										borderStyle: 'solid',
										color: btnColorFirst,
										borderRadius: borderRadiusFirst,
								  }
						}
						target={target === true ? '_blank' : '_self'}
						href={btnLinkFirst}
						rel={rel}
						className={
							btnStyleFirst === 'fill'
								? 'asl-btn-cta-1 asl-btn-first asl-fill'
								: 'asl-btn-cta-1 asl-btn-first asl-outline'
						}
					/>
					<RichText.Content
						tagName="a"
						value={btnText2}
						style={
							btnStyleSecond === 'fill'
								? {
										color: btnColorSecond,
										backgroundColor: btnBackgroundSecond,
										borderRadius: borderRadiusSecond,
								  }
								: {
										borderWidth: borderWidthSecond,
										borderColor: btnBorderColorSecond,
										borderStyle: 'solid',
										color: btnColorSecond,
										borderRadius: borderRadiusSecond,
								  }
						}
						target={target === true ? '_blank' : '_self'}
						href={btnLinkSecond}
						rel={rel}
						className={
							btnStyleSecond === 'fill'
								? 'asl-btn-cta-1 asl-btn-second asl-fill'
								: 'asl-btn-cta-1 asl-btn-second asl-outline'
						}
					/>
				</div>
				<RichText.Content
					tagName="div"
					className="asl-cta-1-content"
					value={body}
				/>
			</div>
		);
	},
};

const deprecated = [v1];

export default deprecated;
